export var WebhookActionType;
(function (WebhookActionType) {
    WebhookActionType[WebhookActionType["GENERATE"] = 0] = "GENERATE";
    WebhookActionType[WebhookActionType["REMOVE"] = 1] = "REMOVE";
})(WebhookActionType || (WebhookActionType = {}));
